import ServiceBase from "./ServiceBase"

const resource = "/products"

export default
	{
		getProducts()
		{
			return ServiceBase.get(resource)
		},
		getProduct(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updateProduct(payload)
		{
			return ServiceBase.put(resource + "/" + payload.id, payload)
		},
		addProduct(payload)
		{
			return ServiceBase.post(resource, payload)
		},
		deleteProduct(id)
		{
			return ServiceBase.delete(resource + "/" + id)
		}
	}